import { locationIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import { InventoryAdjustmentKind } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const AdjustmentHistoryItemSchema_ = z.object({
  id: z.string(),
  kind: createEnum(InventoryAdjustmentKind),
  kindDisplay: z.string(),
  quantityDelta: z.number(),
  committedDelta: z.number(),
  notes: z.string().nullable(),
  referenceId: z.string().nullable(),
  createdAt: z.string(),
});

export const AdjustmentHistoryItemSchema: z.ZodType<AdjustmentHistoryItem> =
  AdjustmentHistoryItemSchema_;
export interface AdjustmentHistoryItem
  extends z.infer<typeof AdjustmentHistoryItemSchema_> {}

export const listAdjustmentHistory = {
  name: "listAdjustmentHistory" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
    sortDirection: createEnum(["asc", "desc"]).default("desc"),
    limit: z.number().default(50),
    offset: z.number().default(0),
  }),
  output: z.object({
    items: z.array(AdjustmentHistoryItemSchema),
    total: z.number(),
  }),
};

export { InventoryAdjustmentKind } from "@redotech/redo-prisma-client/enums";
